import type { Measure, MeasureMetadata } from '../../api/work-periods-client/work-periods-client.type';
import type {
  ChartData,
  ComparisonMode,
  KPICard,
  Tab,
  ViewMode,
} from '../../containers/process-analysis-v2/process-analysis-v2.type';

enum Panel {
  Filters = 'filters',
  Side = 'side',
}

type State = {
  activeTab: Tab;
  viewMode: ViewMode;
  comparisonMode: ComparisonMode;
  activePanel: Panel | null;
  dateRange: {
    startDate: string;
    endDate: string;
  };
  availableMeasures: MeasureMetadata[];
  kpiData: KPICard[];
  chartData: ChartData | null;
  selectedPortfolios: string[];
  selectedTeams: string[];
  selectedBoards: string[];
  selectedMeasures: Measure[];
  selectedMeasureTrends: Measure[];
};

export { Panel };
export type { State };
